import { useEffect, useState } from 'react'
import { gql } from '@apollo/client'
import { apolloClient } from 'lib/apollo'
import { MasterData, Query } from 'types/graphql'

const QUERY_PREFECTURES = gql`
  query {
    getMasterData(name: PREFECTURE) {
      code
      displayName
    }
  }
`

const useQueryPrefectures = (): MasterData[] => {
  const [prefectures, setPrefectures] = useState<MasterData[]>([])
  useEffect(() => {
    ;(async () => {
      const { error, data } = await apolloClient.query<Query>({ query: QUERY_PREFECTURES })
      if (error) {
        console.error(error)
        return
      }
      if (data?.getMasterData) {
        setPrefectures([...data.getMasterData])
      }
    })()
  }, [])
  return prefectures
}

export default useQueryPrefectures
